<template>
  <div class="creditAcountDetail">
    <div class="content">
      <div class="back" @click="goBack">
        <md-icon name="arrow-left" size="xs" style="font-size: 0.24rem;"></md-icon>
        <span>返回</span>
      </div>
      <div class="tl">
        <div class="left">
          <span>{{sum.buyer_name}}</span>
          <span>
            赊欠金额共
            <span>{{sum.credit_amount_sum*1}}</span>元
          </span>
          <span>，{{sum.count}}单，</span>
          <span>
            还款金额
            <span>{{sum.annal_sum*1}}</span>
            元
          </span>
          <span>
            未还金额
            <span>{{sum.last_credit_sum*1}}</span>
            元
          </span>
        </div>
        <div class="time">
          <Calendar v-model="data_picker" @change="changeTime"></Calendar>
        </div>
      </div>
      <div class="listBox" v-if="list.length>0">
        <div class="title">
          <span>序号</span>
          <span>时间</span>
          <span>日单号</span>
          <span>订单金额</span>
          <span>赊欠金额</span>
          <span>还款金额</span>
          <span>未还金额</span>
          <span></span>
        </div>
        <div class="detailBox">
          <md-scroll-view
            ref="scrollView"
            :auto-reflow="false"
            :bouncing="true"
            :scrolling-x="false"
            @end-reached="$_onEndReached"
          >
            <div
              v-for="(item,index) in list"
              :key="index"
              class="list"
              @click="lookDetail(item.order_sn)"
            >
              <span>{{index+1}}</span>
              <span>{{item.create_time}}</span>
              <span>
                <span>{{item.day_num}}</span>
              </span>
              <span>{{item.order_amount*1}}元</span>
              <span>{{item.credit_amount*1}}元</span>
              <span>{{item.annal*1}}元</span>
              <span>{{item.last_credit*1}}元</span>
              <span>
                <md-icon name="arrow-right" size="sm"></md-icon>
              </span>
            </div>
            <md-scroll-view-more
              :finished-text="list.length>0?'全部已加载':'暂无数据'"
              slot="more"
              :is-finished="isFinished"
            ></md-scroll-view-more>
          </md-scroll-view>
        </div>
      </div>
      <div v-if="list.length==0" style="text-align:center;color:#999;line-height:0.8rem">暂无数据~</div>
    </div>
    <!-- 订单详情 -->
    <orderDetail
      :pop_show="isPopupShow"
      :orderId="orderId"
      @cancel="isPopupShow=false;orderId = ''"
    />
  </div>
</template>
<script>
import { timestampToDate, timestampToTime } from "@/utils/timestamp";
import { credit_Acount_Detail } from "@/api/work/acount/creditAcount";
import orderDetail from "../../order/orderDetail";
import Calendar from "@/components/Calendar";
export default {
  name: "creditAcountDetail",
  components: {
    orderDetail,
    Calendar,
  },
  filters: {
    toDate(t) {
      return timestampToDate(t);
    },
    toTime(t) {
      return timestampToTime(t);
    },
  },
  data() {
    return {
      unit_list: [
        { value: 1, name: "件" },
        { value: 2, name: "包" },
        { value: 3, name: "袋" },
        { value: 4, name: "盒" },
        { value: 5, name: "瓶" },
        { value: 6, name: "箱" },
        { value: 7, name: "罐" },
      ],
      dataQuery: {
        //传参
        buyer_id: "",
        orderby: "",
        desc: "",
        s: "",
        e: "",
        page: 1,
        pagesize: 55,
      },
      data_picker: [],
      sum: {
        //总数据
        buyer_name: "",
        annal_sum: "",
        last_credit_sum: "",
        count: "",
        credit_amount_sum: "",
      },
      list: [],
      isFinished: false,
      isPopupShow: false, //是否显示右边详情
      orderId: "",
    };
  },
  created() {
    this.dataQuery.buyer_id = this.$route.query.buyer_id;
    if (this.$route.query.s) {
      this.dataQuery.s = this.$route.query.s;
      this.dataQuery.e = this.$route.query.e;
      this.data_picker[0] = new Date(this.$route.query.s).getTime() / 1000;
      this.data_picker[1] = new Date(this.$route.query.e).getTime() / 1000;
    }
    this.getList();
  },
  mounted() {},
  methods: {
    //选择时间
    changeTime(e) {
      if (this.data_picker) {
        this.dataQuery.s = timestampToDate(this.data_picker[0]);
        this.dataQuery.e = timestampToDate(this.data_picker[1]);
      } else {
        this.dataQuery.s = "";
        this.dataQuery.e = "";
      }
      this.dataQuery.page = 1;
      this.list = [];
      this.getList();
    },
    getList() {
      if (this.dataQuery.page == 1) {
        this.list = [];
      }
      credit_Acount_Detail(this.dataQuery).then((res) => {
        if (res.code == 200) {
          this.sum.buyer_name = res.data.buyer_name;
          this.sum.credit_amount_sum = res.data.credit_amount_sum;
          this.sum.count = res.data.count;
          this.sum.annal_sum = res.data.annal_sum;
          this.sum.last_credit_sum = res.data.last_credit_sum;
          this.list = this.list.concat(res.data.list);
          if (
            this.list.length == res.data.totalCount ||
            res.data.list.length == 0
          ) {
            this.isFinished = true;
          } else {
            this.isFinished = false;
            this.dataQuery.page++;
          }
        }
      });
    },
    //下拉刷新
    $_onEndReached() {
      if (this.isFinished) {
        return;
      }
      // async data
      this.getList();
      this.$refs.scrollView.finishLoadMore();
    },
    //返回上一级
    goBack() {
      this.$router.go(-1);
    },
    lookDetail(order_sn) {
      if (order_sn) {
        this.orderId = order_sn;
        this.isPopupShow = true;
      } else {
        this.$toast.info("补录订单");
      }
    },
  },
};
</script>

<style lang="less" scoped>
.creditAcountDetail {
  padding: 0.1rem;
  height: 100%;
  padding-bottom: 0;

  .content {
    padding: 0.2rem;
    height: 100%;
    background: #fff;
    border-radius: 0.1rem;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    .back {
      margin-bottom: 0.26rem;
      color: #31b158;
      font-weight: bold;
      font-size: 0.24rem;
      height: 0.32rem;
    }
    .tl {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 0.32rem;
      margin: 0 0.22rem;
      .left {
        span {
          font-size: 0.22rem;
          color: #404040;
        }
        > span {
          margin-left: 0.12rem;
          > span {
            color: #31b158;
          }
        }
      }
    }
    .listBox {
      margin: 0 0.22rem;
      margin-top: 0.12rem;
      height: calc(100% - 0.32rem - 0.32rem - 0.2rem);
      .title {
        height: 0.68rem;
        border-top: 0.01rem solid #e5e5e5;
        border-bottom: 0.01rem solid #e5e5e5;
        display: flex;
        justify-content: space-between;
        align-items: center;
        span {
          font-size: 0.22rem;
          color: #555;
          font-weight: bold;
          text-align: center;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
        span:nth-of-type(1) {
          width: 0.6rem;
          text-align: left;
        }
        span:nth-of-type(2) {
          width: 1.4rem;
        }
        span:nth-of-type(3) {
          width: 1rem;
          text-align: center;
        }
        span:nth-of-type(4) {
          width: 2rem;
        }
        span:nth-of-type(5) {
          width: 2rem;
        }
        span:nth-of-type(6) {
          width: 2rem;
        }
        span:nth-of-type(7) {
          width: 2rem;
        }
        span:nth-of-type(8) {
          width: 1rem;
        }
      }
      .detailBox {
        height: calc(100% - 0.68rem);
        font-size: 0.18rem;
        .list {
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 0.6rem;
          border-bottom: 0.01rem solid #e5e5e5;
          > span {
            text-align: center;
            color: #666666;
          }
          span:nth-of-type(1) {
            width: 0.6rem;
            text-align: left;
          }
          span:nth-of-type(2) {
            width: 1.4rem;
          }
          span:nth-of-type(3) {
            width: 1rem;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
          span:nth-of-type(4) {
            width: 2rem;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
          span:nth-of-type(5) {
            width: 2rem;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
          span:nth-of-type(6) {
            width: 2rem;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
          span:nth-of-type(7) {
            width: 2rem;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }

          span:nth-of-type(8) {
            width: 0.8rem;
            font-size: 0.22rem;
            font-weight: bold;
          }
        }
      }
    }
  }
}
</style>
<style lang="less">
.time {
  .calendar_select_box {
    width: 2.6rem!important;
    border: 0.01rem solid #e5e5e5!important;
    background: #fff !important;
  }
}
</style>